import { ConfirmDialog } from '@shared/components/feedback/ConfirmDialog'
import { useContext, useEffect } from 'react'
import { UNSAFE_DataRouterContext, useBlocker } from 'react-router'

function NavigationBlocker({ active }: { active: boolean }) {
  const blocker = useBlocker(active)
  return (
    <ConfirmDialog
      open={blocker.state === 'blocked'}
      variant="warning"
      title="Sair sem salvar?"
      description="Você mudou algo e ainda não salvou. Se sair agora, essas mudanças serão perdidas."
      confirmText="Sair sem salvar"
      cancelText="Continuar editando"
      onClose={() => blocker.state === 'blocked' && blocker.reset()}
      onConfirm={() => blocker.state === 'blocked' && blocker.proceed()}
    />
  )
}

export function UnsavedChanges({ dirty, saving = false }: { dirty: boolean; saving?: boolean }) {
  const dataRouter = useContext(UNSAFE_DataRouterContext)
  const active = dirty && !saving
  useEffect(() => {
    if (!active) return
    const handle = (event: BeforeUnloadEvent) => {
      event.preventDefault()
      event.returnValue = ''
    }
    window.addEventListener('beforeunload', handle)
    return () => window.removeEventListener('beforeunload', handle)
  }, [active])
  return dataRouter ? <NavigationBlocker active={active} /> : null
}
